module.exports = "/fast-coin/fonts/proxima-nova-semibold.otf";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/fonts/proxima-nova-semibold.otf
// module id = 1870
// module chunks = 4